<template>
    <div class="layout-maxed">
        <a class="focusable visually-hidden" href="#main">Aller au contenu</a>

        <header class="layout-hero header">
            <div class="wrap">
                <div class="logo">
                    <transition name="fade-up" mode="in-out">
                        <img alt="Logo de hkevin.fr" src="@/assets/logo.svg" v-if="switchLogo">
                    </transition>
                </div>
                <div class="header">
                    <the-navigation></the-navigation>
                </div>
            </div>
            <transition name="fade-up--delay">
                <div class="animated" v-if="!switchLogo">
                    <div class="sphere"></div>
                    <div class="sphere"></div>
                </div>
            </transition>
        </header>
    </div>
</template>

<script>
import TheNavigation from './TheNavigation.vue'

export default {
    components: {
        TheNavigation
    },
    computed: {
        switchLogo() {
          return this.$store.getters.headerTheme === ''
      },
    },
}
</script>

<style lang="scss" scoped>


.logo {
    width: 85px;
    height: 85px;
    float: left;
}

.header {
    padding-top: 0.5em;
    text-align: center;
}

.animated {
    position: absolute;
    top: -10em;
    right: 0em;
}

.sphere {
    width: 60vh;
    height: 60vh;
    background: #fff;
    background: linear-gradient(#fff, transparent);
    border-radius: 50%;
    opacity: 0.4;

    @media only screen and (max-height: 1024px) {
        width: 65vh;
        height: 65vh;
    }

    &:nth-child(2) {
        width: 20vh;
        height: 20vh;
        margin-top: -10em;
        margin-left: 5em;
        opacity: 0.2;
    }
}



@media (max-width: 768px) {
    .logo {
        padding-top: 0.75em;
        width: 55px;
        height: 55px;
    }

    .layout-maxed {
        grid-template-columns: minmax(1rem, 1fr) minmax(auto, 768px) minmax(1rem, 1fr);
    }
}
</style>